import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

import useAnimatedTheme from "$src/core/hooks/use-animated-theme";

const stylesheet = StyleSheet.create(
  ({ spacing, border, colors, breakpoints }) => {
    const tabBarHeight = spacing(18);

    return {
      page: {
        _web: {
          overflowY: "auto",
        },
      },
      header: {
        paddingVertical: spacing(8),
        gap: spacing(12),
        _web: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
          transition: "all 0.2s ease-out",
        },
      },
      headerInner: {
        maxWidth: breakpoints.xxl,
        marginHorizontal: "auto",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        paddingHorizontal: {
          xs: spacing(6),
          md: spacing(8),
        },
      },
      footer: {
        maxWidth: breakpoints.xxl,
        width: "100%",
        marginHorizontal: "auto",
        paddingVertical: spacing(12),
      },
      center: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      },
      right: {
        alignItems: "flex-end",
      },
      logo: {
        height: spacing(12),
        width: spacing(32),
      },
      profile: {
        borderRadius: border.radius.full,
        backgroundColor: colors.backgroundBrand,
        padding: spacing(2),
        borderWidth: border.widths.md,
        borderColor: "transparent",
      },
      profileActive: {
        borderColor: colors.borderDefault,
        backgroundColor: colors.backgroundBrand,
      },
      profileIcon: {
        color: colors.foregroundOnBrand,
        width: spacing(6),
        height: spacing(6),
      },
      tabBar: {
        height: tabBarHeight,
        _web: {
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1,
        },
      },
      content: {
        paddingBottom: {
          xs: tabBarHeight,
          lg: spacing(12),
        },
        _web: {
          minHeight: "100vh",
        },
      },
    };
  },
);

export const useAnimatedStyles = ({
  scrollY,
}: {
  scrollY: SharedValue<number>;
}) => {
  const theme = useAnimatedTheme();

  const headerStyle = useAnimatedStyle(() => ({
    backgroundColor:
      scrollY.value > 0 ? theme.value.colors.backgroundDefault : "transparent",
    paddingTop: scrollY.value > 0 ? 16 : 32,
    paddingBottom: scrollY.value > 0 ? 16 : 32,
  }));

  return {
    headerStyle,
  };
};

export default stylesheet;
